var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduccion1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_1596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.94977 6.48049H7.95182L12.3182 4.57349L7.94977 6.47843V6.48049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9467 3.58492C15.9447 3.4549 15.8791 3.33313 15.7704 3.2609C15.7663 3.25883 15.7643 3.25677 15.7602 3.2547C15.7253 3.21755 15.6802 3.18866 15.631 3.16802L7.97438 0L0.405894 3.33107C0.379244 3.34345 0.352594 3.3579 0.330045 3.37854C0.319795 3.38473 0.307495 3.39092 0.297245 3.39711L0.129148 3.51269L0 13.7783L7.54388 16.9051C7.59923 16.9278 7.65663 16.9401 7.71403 16.9422C7.77553 16.9814 7.84523 17 7.91493 17C7.96413 17 8.01332 16.9897 8.06252 16.9711L16 13.7226L15.9467 3.58492ZM7.53158 16.1208L0.719539 13.2995L0.834337 4.22885L7.59308 7.10999L7.53158 16.1208ZM1.38578 3.68399L7.98257 0.780138L14.6716 3.54777L12.3183 4.57557L7.95183 6.48258H7.94773L1.38578 3.68399ZM8.24497 16.1208L8.30647 7.10999L12.3736 5.33507L15.2354 4.08438L15.2846 13.2396L8.24497 16.1208Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_1596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduccion1);
export default __webpack_public_path__ + "static/media/produccion 1.29fbc7a57aba82aedf2e7d479d105ceb.svg";
export { ForwardRef as ReactComponent };